<template>
  <div>
    <h2>Regioes país</h2>
    
    <div v-if="filtered.length">
      <b-table striped hover show-empty :items="filtered" :fields="fields">
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.key">
              <b-form-input
                v-model="filters[field.key]"
                :placeholder="'Buscar por ' + field.label"
              />
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(prazo)="row">
          <b-form-input v-model="row.item.prazo" v-on:change="onDataChange(row.item)" />
        </template>
        <template v-slot:cell(diasPosColeta)="row">
          <b-form-input v-model="row.item.diasPosColeta" v-on:change="onDataChange(row.item)" />
        </template>
      </b-table>
    </div>
    <div v-else>
      <b-table striped show-empty :items="filtered" :fields="fields">
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.key">
              <b-form-input
                v-model="filters[field.key]"
                :placeholder="'Buscar por ' + field.label"
              />
            </b-th>
          </b-tr>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PrazoEntregaRegioesPais",
  props: {
    transportadorId: null
  },
  computed: {
    filtered() {
      const filtered = this.items.filter(item => {
        return Object.keys(this.filters).every(key => {
          let sections = key.split(".");
          let object = item;
          for (let i = 0; i < sections.length; i++) {
            object = object[sections[i]];
          }
          return String(object)
            .toUpperCase()
            .includes(this.filters[key].toUpperCase());
        });
      });
      return filtered;
    }
  },
  data: function() {
    return {
      fields: [
        {
          label: "Região país",
          key: "regiaoPais.nome",
          sortable: true
        },
        {
          label: "Prazo",
          key: "prazo",
          sortable: true
        },
        {
          label: "Dias pos coleta",
          key: "diasPosColeta",
          sortable: true
        }
      ],
      filters: {
        "regiaoPais.nome": "",
        prazo: "",
        diasPosColeta: ""
      },
      items: []
    };
  },
  created: function() {
    this.loadData();
  },
  watch: {
    transportadorId() {
      this.loadData();
    }
  },
  methods: {
    async loadData() {
      if (this.transportadorId) {
        this.$api
          .get("/rotaPrazoEntrega/regioesPais/" + this.transportadorId.toString())
          .then((response) => {
            this.items = response.data;
          })
          .catch((error) => {
            console.log(error);
            this.items = [];
          });
      } else {
        console.log("load regioesPais without transportadorId");
        this.$api
          .get("/rotaPrazoEntrega/regioesPais/1")
          .then((response) => {
            this.items = response.data;
          })
          .catch((error) => {
            console.log(error);
            this.items = [];
          });
      }
    },
    onDataChange: function(item) {
      item.prazo = parseInt(item.prazo);
      item.diasPosColeta = parseInt(item.diasPosColeta);

      this.$api
        .post(
          "/rotaPrazoEntrega/save/" + item.transportadorId.toString() + "/" + item.id.toString()
            ,item
        )
        .then((response) => {
          item.id = response.data.id;
          console.log(JSON.stringify(item));
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);

          if (error.response.status == 400) {
            alert(error.response.data.errors);
          }
        });
    }
  }
};
</script>

